<template>
  <v-dialog v-model="show" width="80%">
    <v-card>
      <v-card-title>
        <span class="headline">サービスパーツ商品EIAJ検収伝票発行設定</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="confirm" class="ml-2 mr-2">確定</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex>
              <remote-autocomplete
                label="SJL納入場所"
                url="warehouses/kv"
                v-model="query.sjlWarehouseId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex>
              <remote-autocomplete
                :label="$t('app.labels.scWarehouse')"
                url="warehouses/kv"
                v-model="query.finallyWarehouseId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex>
              <date-picker label="受入予定日時間" v-model="query.forecastAcceptanceTime"></date-picker>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    show: false,
    radioGroup: '',
    query: {}
  }),
  methods: {
    popup() {
      this.show = true
    },
    confirm() {
      this.$emit('popData', this.query)
      this.query = {}
      this.show = false
    }
  }
}
</script>
